import { ODBDetailsAction } from '../actions/ODBDetailsAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "ODBDetails",
        steps: [
            {
                sequence: "0",
                stepId: "ODBDetails",
                fields: [
                    {
                        name: "City",
                        value: ""
                    },
                    {
                        name: "District",
                        value: ""
                    },
                    {
                        name: "Region",
                        value: ""
                    },
                    {
                        name: "Feasibility ID",
                        value: ""
                    }
                ]
            }
        ]
    },
    feasibilityCheckResponse: {

    }
}

const ODBDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var ODBDetailsValue = { ...state.requestBody.steps };

    switch (type) {

        case ODBDetailsAction.FTTH_FEASIBILITY_CHECK_SUCCESS:
            return { ...state, feasibilityCheckResponse: payload };

        case ODBDetailsAction.UPDATE_ODB_DETAILS:
            ODBDetailsValue[0].fields[0].value = payload.city;
            ODBDetailsValue[0].fields[1].value = payload.district;
            ODBDetailsValue[0].fields[2].value = payload.region;
            ODBDetailsValue[0].fields[3].value = payload.FeasibilityID;

            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, feasibilityCheckResponse: {} }

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'ODBDetails')
            });
            if (section.length > 0) {
                for (let i = 0; i < ODBDetailsValue[0].fields.length; i++) {
                    const checkoutField = section[0].steps[0].fields.filter((field: any) => { return (field.name === ODBDetailsValue[0].fields[i].name) })[0];
                    ODBDetailsValue[0].fields[i].value = checkoutField ? checkoutField.value : "";
                }
            }
            return state;

        default:
            return state;
    }

}

export default ODBDetailsReducer;